// MOCK DATA — no backend yet. Waitlist submissions are stored in localStorage.

export const site = {
  brand: "InZoRAH",
  kicker: "First light on everything you consume",
  headline: "Stop Guessing. Start Knowing.",
  lede:
    "Scan any product \u2014 food, supplements, or skincare \u2014 and instantly see what\u2019s really inside it. Inzorah decodes ingredients so you don\u2019t have to.",
  hint: "Start Scanning Free \u2014 live now on Google Play, iOS next.",
  tagline: "Your health starts at the store. Inzorah makes sure you\u2019re ready.",
  featuresHeadline: "Everything You Need to Shop with Confidence",
  fine:
    "Educational information, not medical advice. Always read the physical label if you have an allergy.",
  company: "KYSolutions LLC",
  email: "support@inzorah.com",
  updated: "Last updated August 2026",
  playUrl: "https://play.google.com/store/apps/details?id=com.inzorah",
  appStoreUrl: "",
};

export const socials = [
  {
    id: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/1375126572344880",
  },
  {
    id: "instagram",
    label: "Instagram",
    url: "https://www.instagram.com/inzorah/",
  },
  { id: "x", label: "X", url: "" },
  { id: "tiktok", label: "TikTok", url: "" },
];

export const tiles = [
  {
    n: 1,
    title: "Ingredient Scanner",
    text:
      "Scan any barcode and get an instant, easy-to-read ingredient breakdown for food, supplements, and cosmetics.",
  },
  {
    n: 2,
    title: "Smart Comparisons",
    text:
      "Compare two products side by side so you always pick the healthier option \u2014 no guesswork, no confusion.",
  },
  {
    n: 3,
    title: "Grocery List",
    text:
      "Build organized shopping lists before every trip and stay focused on what matters \u2014 your health goals.",
  },
  {
    n: 4,
    title: "Progress Tracking",
    text:
      "Your shopping history tells a story. Track how your habits are improving and celebrate every healthy choice.",
  },
];

export const legalIndex = [
  {
    slug: "privacy",
    title: "Privacy Policy",
    blurb: "What we collect, why, and how to delete it.",
  },
  {
    slug: "terms",
    title: "Terms of Service",
    blurb: "The rules for using InZoRAH.",
  },
  {
    slug: "subscription",
    title: "Subscription & Refunds",
    blurb: "Premium pricing, renewals and cancelling.",
  },
  {
    slug: "health",
    title: "Health Disclaimer",
    blurb: "Educational information, not medical advice.",
  },
  {
    slug: "affiliate",
    title: "Affiliate Disclosure",
    blurb: "How we earn from product links.",
  },
];

export const legalDocs = {
  privacy: {
    title: "Privacy Policy",
    blurb: "What we collect, why, and how to delete it.",
    sections: [
      {
        h: "Who we are",
        p: [
          'InZoRAH is operated by KYSolutions LLC ("we", "us"). This policy explains what personal information the app collects, how it is used, and the choices you have. Questions go to support@inzorah.com.',
        ],
      },
      {
        h: "What we collect",
        p: [
          "Account details: your name, email address and \u2014 for email sign-ups \u2014 a password that we store only as a one-way cryptographic hash. We never store your password itself. If you sign in with Google, we receive your name, email and profile image from Google; we never receive your Google password.",
          "Email addresses for launch and waitlist sign-ups: if you ask to be told when InZoRAH launches, we store the email address you give us and use it only to send you that announcement and related product updates. You can ask us to delete it at any time by emailing support@inzorah.com, and every message includes an unsubscribe link.",
          "Barcode and scan history: when you scan a barcode, photograph a label or ask about a product, we store that scan \u2014 the barcode number, the product identified, the ingredient text read from the label, your question and the result \u2014 so you can see your history, keep products, get recall alerts and avoid re-scanning. Scan history is tied to your account. You can delete individual scans, delete them in bulk, or delete your whole account, which removes all of it.",
          "Profile you choose to give us: diet, allergies, skin concerns, ingredients you avoid, budget preference and an optional profile photo. All of it is optional and exists only to personalise your results.",
          "Product activity: the products you scan or ask about, the products you keep, your shopping list, watchlist and any household circle you join.",
          "Technical basics and analytics: app version, device platform, crash and error logs, and \u2014 if you turn on notifications \u2014 a device push token. We also record anonymous usage analytics such as which screens and features are opened, which buttons are tapped, and a two-letter country code, so we can see what works and fix what does not. Analytics events are not used to build advertising profiles and are not sold.",
          "Payment: if you subscribe, Stripe or the app store processes your payment. We receive a confirmation and plan status. We never see or store your full card number.",
        ],
      },
      {
        h: "Where product information comes from",
        p: [
          "To identify a product from a barcode and to read its ingredient list, we look it up in public and third-party product databases, including Open Food Facts, Open Beauty Facts, UPCitemdb, USDA FoodData Central and openFDA, as well as manufacturers\u2019 own published records.",
          "When we do this we send only the barcode number or product name \u2014 never your name, your email address or anything about your profile. These services have their own privacy policies and terms, and the accuracy and completeness of their records is outside our control.",
        ],
      },
      {
        h: "What we do NOT collect",
        p: [
          "We do not sell your personal information and we do not share it with data brokers. We do not run third-party advertising networks or ad trackers inside the app, and we do not use your data for targeted advertising. We do not access your camera roll, microphone, camera or location unless you tap a feature that needs it and grant permission \u2014 and we only use it for that action.",
        ],
      },
      {
        h: "Affiliate shopping links",
        p: [
          "Some product links in the app and on our website are affiliate links. We take part in the Amazon Associates program and the Walmart affiliate program, and we may join other retailer programs. These links contain a tracking code so the retailer can tell that the visit came from us, and we may earn a small commission if you buy something \u2014 at no extra cost to you.",
          "When you tap one of those links you leave InZoRAH and the retailer\u2019s own privacy policy and cookies apply. We do not receive your name, address or payment details from the retailer, only aggregate reports of clicks and qualifying orders. Commissions never change which products we recommend or the scores we show.",
        ],
      },
      {
        h: "How we use it",
        p: [
          "To analyse ingredients and personalise scores, warnings and recommendations for you.",
          "To run your account: sign-in, email verification, password resets, referrals and subscription status.",
          "To send transactional email you asked for (verification codes, password resets, a welcome note, launch or waitlist announcements, and the weekly digest if you opt in) and product-recall alerts.",
          "To keep the service working and safe: debugging, abuse prevention and rate limiting.",
          "To understand and improve the experience using anonymous, aggregated analytics \u2014 for example seeing that a feature is never used, or that a screen is slow.",
        ],
      },
      {
        h: "Who we share it with",
        p: [
          "Service providers only, and only what they need: AI analysis providers (Anthropic Claude and OpenAI, via our managed integration layer) receive ingredient text and your question \u2014 not your name or email; Stripe handles payments; our managed email provider delivers your emails; Google handles sign-in if you choose it; Firebase and Expo deliver push notifications; MongoDB hosts our database.",
          "Product reference sources we query receive only product names or barcodes \u2014 never anything about you. These include Open Food Facts, Open Beauty Facts, UPCitemdb, USDA FoodData Central, openFDA, PubMed, Wikidata, and retailer catalogues such as Amazon, Walmart and Google Shopping.",
          "Analytics: usage events are stored in our own database. We do not send them to an advertising network.",
          "We may disclose information if legally required, or to protect our rights and users.",
        ],
      },
      {
        h: "Your choices and rights",
        p: [
          "You can edit or clear your profile, delete individual scans, or delete your scan history in bulk at any time from inside the app.",
          "You can permanently delete your entire account from Profile \u2192 Delete my account. That immediately removes your account, email, password hash, scan and barcode history, sessions, referral record and payment records. Deletion cannot be undone.",
          "You can unsubscribe from launch, waitlist and digest emails using the link in any message, or by emailing support@inzorah.com, and we will remove your address.",
          "Depending on where you live you may have rights to access, correct, export or delete your data, and to withdraw consent. Email support@inzorah.com and we will respond within 30 days.",
          "You can turn notifications, the weekly digest and optional analytics collection off at any time in the app\u2019s settings.",
        ],
      },
      {
        h: "Keeping it and keeping it safe",
        p: [
          "We keep your data while your account is open, and delete account data when you delete your account. Backups and legally required records may persist for a short period afterwards.",
          "Data travels over encrypted connections, passwords are hashed with Argon2, sessions expire, and repeated failed sign-ins are throttled. No system is perfectly secure, so please use a strong, unique password.",
        ],
      },
      {
        h: "Children",
        p: [
          "InZoRAH is not intended for children under 13, and we do not knowingly collect their information. If you believe a child has an account, contact support@inzorah.com and we will delete it.",
        ],
      },
      {
        h: "International users",
        p: [
          "We operate from the United States, so your information is processed there. If you use the app from outside the US, you consent to that transfer.",
        ],
      },
      {
        h: "Changes",
        p: [
          "If we make a material change to this policy we will update the date below and, where appropriate, tell you in the app.",
        ],
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    blurb: "The rules for using InZoRAH.",
    sections: [
      {
        h: "Agreement",
        p: [
          "By creating an account or using InZoRAH you agree to these terms with KYSolutions LLC. If you do not agree, please stop using the app.",
        ],
      },
      {
        h: "Your account",
        p: [
          "You must be at least 13 years old. Give accurate information, keep your password private, and tell us if you think someone else is using your account. You are responsible for activity under your account.",
          "One person, one account. Referral rewards are for genuine new sign-ups only \u2014 creating accounts to farm rewards may cost you access.",
        ],
      },
      {
        h: "What InZoRAH is",
        p: [
          "InZoRAH reads ingredient lists and public product records and explains them in plain language. It is an information and shopping-assistance tool. It is not a medical, nutritional, dermatological or regulatory authority, and it is not a substitute for reading the physical label on the product in your hand.",
          "Product data comes from third parties and from AI reading of labels. Formulas change, records go stale, and packaging varies by region. We show you where each fact came from so you can judge it \u2014 always check the actual package for allergens.",
        ],
      },
      {
        h: "Third-party product databases",
        p: [
          "To identify products and their ingredients we rely on third-party and community databases, including Open Food Facts, Open Beauty Facts, UPCitemdb, USDA FoodData Central and openFDA, plus manufacturers\u2019 published records. We send them only a barcode or product name.",
          "We do not own or control those databases and cannot guarantee that their records are accurate, complete or current. Their content is provided under their own licences and terms, and any name or trademark shown belongs to its owner.",
        ],
      },
      {
        h: "Scans and the data you generate",
        p: [
          "When you scan a barcode or a label, we store that scan and its result in your account so you can see your history, keep products and receive recall alerts. You can delete individual scans, clear your history, or delete your account and all of its data at any time \u2014 see the Privacy Policy for details.",
          "If you give us an email address to be told when the app launches, we use it only for that announcement and related updates, and you can unsubscribe at any time.",
        ],
      },
      {
        h: "Affiliate links and analytics",
        p: [
          "Some shopping links are affiliate links: we take part in the Amazon Associates program and the Walmart affiliate program, and may join others. Those links include a tracking code and we may earn a commission on qualifying purchases at no extra cost to you. Commissions never influence our scores, rankings or recommendations \u2014 see the Affiliate Disclosure.",
          "We record anonymous usage analytics (screens opened, features tapped, country) to improve the app. We do not use them for advertising and we do not sell them. See the Privacy Policy for what is collected and how to opt out.",
        ],
      },
      {
        h: "Acceptable use",
        p: [
          "Don\u2019t scrape, resell or bulk-extract our content; don\u2019t attack, overload or reverse engineer the service; don\u2019t upload unlawful content; don\u2019t submit false product information or impersonate a brand; don\u2019t use the app to make claims about a competitor\u2019s product that our data does not support.",
        ],
      },
      {
        h: "Your content",
        p: [
          "You keep ownership of what you submit (photos, submitted ingredient lists, questions). You give us a licence to store and use it to run and improve the service. Product information you submit to the community database may be shown to other users.",
        ],
      },
      {
        h: "Our content",
        p: [
          "The app, its design, text and analysis output are owned by us or our licensors. Product names, brands and trademarks belong to their owners; we reference them for identification only, which is not an endorsement or affiliation.",
        ],
      },
      {
        h: "Availability and changes",
        p: [
          "We may add, change, limit or discontinue features, including free-plan limits, and we may suspend accounts that breach these terms. We aim to give notice for material changes that affect paid plans.",
        ],
      },
      {
        h: "Disclaimers and liability",
        p: [
          'The service is provided "as is" and "as available", without warranties of any kind, to the fullest extent the law allows. We do not guarantee that analysis, scores, prices or availability are accurate, complete or current.',
          "To the fullest extent permitted by law, we are not liable for indirect, incidental or consequential damages, and our total liability is limited to the greater of the amount you paid us in the previous 12 months or US$50.",
          "Nothing here limits liability that cannot be limited by law.",
        ],
      },
      {
        h: "Governing law",
        p: [
          "These terms are governed by the laws of the State of Minnesota, USA, without regard to conflict-of-laws rules. Disputes will be brought in the state or federal courts located in Minnesota.",
        ],
      },
      {
        h: "Contact",
        p: ["Questions about these terms: support@inzorah.com."],
      },
    ],
  },
  subscription: {
    title: "Subscription & Refunds",
    blurb: "Premium pricing, renewals and cancelling.",
    sections: [
      {
        h: "Free plan",
        p: [
          "The free plan includes 12 scans per calendar month and 5 product answers per month. Counters reset at the start of each calendar month. Real-source provenance, your watchlist, recall alerts, household circles and your shopping list stay free.",
        ],
      },
      {
        h: "Premium",
        p: [
          "Premium is $4.99 per month or $39.99 per year. It includes unlimited scans, unlimited product answers, AI coaching, side-by-side comparison and live price checks across stores. Prices are in US dollars and may change with notice for future terms.",
        ],
      },
      {
        h: "Payment and renewal",
        p: [
          "Payments are handled by Stripe or, for in-app purchases, by Apple or Google. Where a plan renews automatically, it renews at the end of each term unless you cancel beforehand.",
        ],
      },
      {
        h: "Cancelling",
        p: [
          "If you bought through the App Store or Google Play, cancel in your store account settings \u2014 deleting the app or your InZoRAH account does not cancel store billing.",
          "If you paid us directly, email support@inzorah.com to cancel. You keep Premium until the end of the period you already paid for.",
        ],
      },
      {
        h: "Refunds",
        p: [
          "Purchases made through the App Store or Google Play are refunded by Apple or Google under their policies \u2014 we cannot issue those refunds.",
          "For payments made directly to us, contact support@inzorah.com within 14 days and we will review it in good faith. Refunds are otherwise at our discretion, except where the law gives you a stronger right.",
        ],
      },
      {
        h: "Promotional codes",
        p: [
          "Free-Premium codes and influencer codes have no cash value, may be limited or expire, and can be withdrawn if abused.",
        ],
      },
    ],
  },
  health: {
    title: "Health Disclaimer",
    blurb: "Educational information, not medical advice.",
    sections: [
      {
        h: "Not medical advice",
        p: [
          "Everything InZoRAH shows \u2014 scores, concern levels, ingredient explanations, recommendations and coaching answers \u2014 is general educational information. It is not medical, nutritional, dermatological or pharmaceutical advice, diagnosis or treatment, and no clinician-patient relationship is created by using the app.",
          "Always talk to a qualified professional before changing your diet, supplements, medication or skincare, especially if you are pregnant or nursing, managing a medical condition, or caring for a child.",
        ],
      },
      {
        h: "Allergies \u2014 read the package",
        p: [
          'If you have an allergy or intolerance, never rely on this app alone. Ingredient records can be out of date, incomplete, region-specific or simply wrong, and manufacturers reformulate without notice. Read the physical label, including the "may contain" statement, every single time.',
        ],
      },
      {
        h: "How our scores work",
        p: [
          "Scores are our own opinionated summary of an ingredient list against public evidence and the preferences you set. They are not a regulatory rating, a safety certification, or a statement that a product is unsafe or illegal. When we cannot find a real source, we hide the score rather than pretend to be certain.",
          "AI-generated readings are labelled as such. We show the source and date behind facts so you can check them yourself.",
        ],
      },
      {
        h: "Recalls",
        p: [
          "Recall alerts come from public FDA enforcement data and are matched automatically, so they can be delayed, incomplete or occasionally mismatched. Always check the lot code on your package and follow official FDA and manufacturer guidance.",
        ],
      },
      {
        h: "Emergencies",
        p: [
          "If you are having a serious reaction, call your local emergency number or a poison control centre immediately. Do not use this app to manage an emergency.",
        ],
      },
    ],
  },
  affiliate: {
    title: "Affiliate Disclosure",
    blurb: "How we earn from product links.",
    sections: [
      {
        h: "We may earn a commission",
        p: [
          "KYSolutions LLC takes part in the Amazon Services LLC Associates Program and the Walmart affiliate program, and may join other retailer affiliate programs. As an Amazon Associate we earn from qualifying purchases. If you tap a shopping link in InZoRAH and buy something, we may receive a small commission at no extra cost to you.",
          "Those links contain a tracking code so the retailer can credit the visit to us. Tapping one takes you to the retailer\u2019s site, where their own privacy policy and cookies apply. We receive only aggregate click and order reports \u2014 never your name, address or payment details.",
        ],
      },
      {
        h: "It does not change what we recommend",
        p: [
          "Recommendations are chosen by analysing ingredient lists and public product data \u2014 never by who pays the highest commission. Brands cannot buy a better score, a higher ranking or a place in your results.",
          "We try to match links to the exact product we recommend. When we cannot verify an exact match, we link to an accurate search instead of guessing.",
        ],
      },
      {
        h: "Prices and availability",
        p: [
          "Prices and stock shown in the app come from third-party sources such as Amazon, Walmart and Google Shopping and can be out of date. The price on the retailer\u2019s page at checkout is the one that applies.",
        ],
      },
      {
        h: "Questions",
        p: ["Ask us anything about this at support@inzorah.com."],
      },
    ],
  },
};
